'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hoursAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/hoursAfter.js
// module id = 339
// module chunks = 1